import { useState } from "react";

import { Tab, Tabs } from "shared/ui/tabs";

import { useTrade } from "../context";
import { SettingsPopover } from "./settings-popover";

export type Tab = "deposit" | "withdraw";

type Props = {
  slippage: string;
  onSlippageChange: (slippage: string) => void;
  tab: Tab;
  onTabChange: (tab: Tab) => void;
};

export const Header = ({
  tab,
  slippage,
  onTabChange,
  onSlippageChange,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { theme } = useTrade();

  return (
    <header className="flex items-center justify-between p-4.5">
      <Tabs color={theme}>
        <Tab
          onClick={() => onTabChange("deposit")}
          isActive={tab === "deposit"}
        >
          + Deposit
        </Tab>
        <Tab
          onClick={() => onTabChange("withdraw")}
          isActive={tab === "withdraw"}
        >
          - Withdraw
        </Tab>
      </Tabs>

      <SettingsPopover
        slippage={slippage}
        onSlippageChange={onSlippageChange}
        open={isOpen}
        onOpenChange={setIsOpen}
        onIsCustomSlippageChange={() => {}}
      />
    </header>
  );
};
